import type { FormGroup } from '@angular/forms';

export const onyxNumberRangeValidator =
  (decimalPlaces = 0, fromControlName = 'from', toControlName = 'to') =>
  (form: FormGroup): void => {
    const fromControl = form.get(fromControlName)!;
    const toControl = form.get(toControlName)!;

    const convertValue = (value: number) =>
      decimalPlaces !== 0 ? value / 10 ** decimalPlaces : value;

    const from = convertValue(fromControl.value);
    const to = convertValue(toControl.value);

    const currentErrors = { ...fromControl.errors };

    if (from != null && to != null && from > to) {
      fromControl.setErrors({ ...currentErrors, numberRange: to });
    } else {
      if (currentErrors?.['numberRange']) delete currentErrors['numberRange'];
      fromControl.setErrors(
        Object.keys(currentErrors).length ? currentErrors : null,
      );
    }
  };
